/**
 * 기능 플래그 (TODO 2.5, 9.19)
 * 다중 매장 영역 진입·메뉴 노출 제어. OFF 시 기존과 동일하게 동작.
 */
export const FEATURE_MULTI_STORE =
  typeof process.env.REACT_APP_FEATURE_MULTI_STORE !== 'undefined'
    ? process.env.REACT_APP_FEATURE_MULTI_STORE === 'true'
    : true;

/**
 * 다중 매장 API 목업 사용 여부 (Phase 8.5).
 * 실서비스 배포 시 false로 설정. true 또는 미설정 시 API 실패 시 목업 반환.
 */
export const USE_MULTI_STORE_MOCK =
  typeof process.env.REACT_APP_USE_MULTI_STORE_MOCK !== 'undefined'
    ? process.env.REACT_APP_USE_MULTI_STORE_MOCK === 'true'
    : true;

/** GPT 버튼: 사용자앱에서도 항상 노출 */
export const FEATURE_GPT_ANALYSIS = true;
